<ng-container>
  <div class="modal-header">
    <h5 class="modal-title">Add new System User</h5>
  </div>
  <div class="modal-body">
    <div class="modal-section">
      All new System Accounts must use a company email domain. Please enter the email address below and select the corresponding Account Type(s). When ready, click "Add System Users" to add them. Note: You are unable to add yourself.
    </div>
    <div class="modal-section">
      <small class="text-muted">
        <strong>Role Descriptions: </strong> 
        <em>Clear Sign Auditor</em> is a read-only role with access to view orders and the Orders Report.
        <em>Clear Sign Support</em> has full access to create, edit, and delete orders and users throughout the portal.
      </small>
    </div>
    <form [formGroup]="addSystemUserForm" class="clrsgn-form">
      <div formArrayName="systemUsers">
        @for (systemUserGroup of addSystemUsersArray.controls; track systemUserGroup; let i = $index) {
          <div [formGroupName]="i">
            @if (i > 0) {
              <hr class="split"/>
            }
            <div class="modal-section">
              New System User {{ i + 1 }}
              @if (i > 0) {
                <span> - <span class="fas fa-trash-alt" (click)="removeUserInvite(i)" ngbTooltip="Remove"></span></span>
              }
            </div>
            <div class="row">
              <mat-form-field appearance="fill" class="invite-form-field">
                <mat-label for="emailAddress" class="clrsgn-label">
                  Email Address
                </mat-label>
                <input matInput
                  maxlength="128"
                  type="text"
                  formControlName="emailAddress"
                  id="emailAddress">
                  <app-form-error [group]="addSystemUserForm"
                  [controlName]="'systemUsers.' + i + '.emailAddress'"></app-form-error>
                </mat-form-field>
              </div>
              <div class="row align-center">
                <mat-form-field appearance="fill" class="invite-form-field">
                  <mat-label for="accountTypes" class="clrsgn-label">
                    Account Types
                  </mat-label>
                  <mat-select formControlName="accountTypes"
                    id="accountTypes"
                    data-cy="accountTypesDropdownList"
                    [multiple]="true">
                    @for (type of accountTypes; track type) {
                      <mat-option
                        [value]="type.key">
                        {{ type.value }}
                      </mat-option>
                    }
                  </mat-select>
                  <app-form-error [group]="addSystemUserForm"
                  [controlName]="'systemUsers.' + i + '.accountTypes'"></app-form-error>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
        <button type="button" class="btn-secondary" (click)="addSystemUser()">+ Add Another</button>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-secondary" (click)="close()">Cancel</button>
      <button type="button" class="btn-primary" (click)="addSystemAccounts()">Add System Users</button>
    </div>
  </ng-container>

